/**
 * 固定在版面底層的兩顆模糊光球，設計系統「大氣質感」的來源，純裝飾。
 *
 * 兩個主題共用同一組不透明度：深色主題若降低不透明度，光球與背景的色差太小而看不見。
 * 光球靠 `bg-accent` 取色，強調色本身是雙主題 token，同一個不透明度在兩個主題仍是不同的顏色。
 *
 * 行動版縮小尺寸以降低模糊運算成本，但保留效果。
 */
export function AmbientBackground() {
  return (
    <div
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
      aria-hidden="true"
    >
      <div className="absolute -top-32 left-1/2 h-[320px] w-[420px] -translate-x-1/2 rounded-full bg-accent opacity-[0.1] blur-[100px] md:h-[420px] md:w-[600px] md:blur-[140px]" />
      <div className="absolute -right-24 bottom-0 h-[280px] w-[280px] rounded-full bg-accent opacity-[0.08] blur-[100px] md:h-[420px] md:w-[420px] md:blur-[140px]" />
    </div>
  );
}
